import { createReducer } from 'reduxsauce';
import { TASK_STATUSES } from '@rapid-recovery-agency-inc/insightt-shared';
import { isEqual, cloneDeep, filter, findIndex } from 'lodash';
import { TaskManagementTypes } from '../actions/taskmanagement.actions';

const initialState = {
  status: [],
  assignerTasks: [],
  filteredAssignerTasks: [],
  receiverTasks: [],
  filteredReceiverTasks: [],
  activeReceivedTasksCount: 0,
  filter: {},
  searchKeyword: '',
  orderColumn: {},
  orderColumns: [
    { column: 'name', label: 'Name' },
    { column: 'status', label: 'Status' },
    { column: 'urgency', label: 'Urgency' },
  ],
};

const getAssignerTasksRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-assigner-tasks');
  return { ...state, status };
};
const getAssignerTasksSuccess = (state, action) => {
  const assignerTasks = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-assigner-tasks', a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks: assignerTasks,
    filter: {},
    searchKeyword: '',
    orderColumn: {},
    status,
  };
};
const getAssignerTasksFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-assigner-tasks', a));
  return { ...state, status };
};

const createNewTaskRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-create-newtask');
  return { ...state, status };
};
const createNewTaskSuccess = (state, action) => {
  const task = action.response;

  const assignerTasks = cloneDeep(state.assignerTasks);
  assignerTasks.push(task);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-newtask', a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks: assignerTasks,
    status,
  };
};
const createNewTaskFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-newtask', a));
  return { ...state, status };
};

const closeTaskRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-close-task-${action.taskId}`);
  return { ...state, status };
};
const readTaskRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-read-task-${action.taskId}`);
  return { ...state, status };
};
const closeTaskSuccess = (state, action) => {
  const { taskId } = action;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-close-task-${taskId}`, a));

  let assignerTasks = cloneDeep(state.assignerTasks);
  assignerTasks = assignerTasks.map((task) => {
    if (task.id === taskId) {
      return {
        ...task,
        status: TASK_STATUSES.closed,
      };
    }
    return task;
  });

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks: assignerTasks,
    status,
  };
};

const readTaskSuccess = (state, action) => {
  const { taskId } = action;

  let receiverTasks = cloneDeep(state.receiverTasks);

  receiverTasks = receiverTasks.map((task) => {
    if (task.id === taskId) {
      return {
        ...task,
        readStatus: true,
      };
    }
    return task;
  });

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks: receiverTasks,
  };
};

const closeTaskFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-close-task-${action.taskId}`, a));
  return { ...state, status };
};

const approveCompletedRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-approve-task-completion-${action.taskId}`);
  return { ...state, status };
};
const approveCompletedSuccess = (state, action) => {
  const assignerTasks = cloneDeep(state.assignerTasks);
  const idxOfAll = findIndex(assignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    assignerTasks[idxOfAll] = action.response;
  }

  const filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
  const idxOfFiltered = findIndex(filteredAssignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredAssignerTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-task-completion-${action.response.id}`, a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks,
    status,
  };
};
const approveCompletedFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-task-completion-${action.taskId}`, a));
  return { ...state, status };
};

const rejectCompletedRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-reject-task-completion-${action.taskId}`);
  return { ...state, status };
};
const rejectCompletedSuccess = (state, action) => {
  const assignerTasks = cloneDeep(state.assignerTasks);
  const idxOfAll = findIndex(assignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    assignerTasks[idxOfAll] = action.response;
  }

  const filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
  const idxOfFiltered = findIndex(filteredAssignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredAssignerTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-reject-task-completion-${action.response.id}`, a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks,
    status,
  };
};
const rejectCompletedFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-reject-task-completion-${action.taskId}`, a));
  return { ...state, status };
};

const approveNewDeadlineRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-approve-new-deadline-${action.taskId}`);
  return { ...state, status };
};
const approveNewDeadlineSuccess = (state, action) => {
  const assignerTasks = cloneDeep(state.assignerTasks);
  const idxOfAll = findIndex(assignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    assignerTasks[idxOfAll] = action.response;
  }

  const filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
  const idxOfFiltered = findIndex(filteredAssignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredAssignerTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-new-deadline-${action.response.id}`, a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks,
    status,
  };
};
const approveNewDeadlineFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-approve-new-deadline-${action.taskId}`, a));
  return { ...state, status };
};

const declineNewDeadlineRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-decline-new-deadline-${action.taskId}`);
  return { ...state, status };
};
const declineNewDeadlineSuccess = (state, action) => {
  const { taskId } = action.response;

  const assignerTasks = cloneDeep(state.assignerTasks);
  const idxOfAll = findIndex(assignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    assignerTasks[idxOfAll] = action.response;
  }
  const filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
  const idxOfFiltered = findIndex(filteredAssignerTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredAssignerTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-decline-new-deadline-${taskId}`, a));

  return {
    ...state,
    assignerTasks,
    filteredAssignerTasks,
    status,
  };
};
const declineNewDeadlineFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-decline-new-deadline-${action.taskId}`, a));
  return { ...state, status };
};

const getReceiverTasksRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-receiver-tasks');
  return { ...state, status };
};
const getReceiverTasksSuccess = (state, action) => {
  const receiverTasks = action.response;

  const activeReceivedTasksCount = receiverTasks.filter(
    (task) => task.status === TASK_STATUSES.open || task.status === TASK_STATUSES.new_deadline_proposed,
  ).length;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-receiver-tasks', a));

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks: receiverTasks,
    activeReceivedTasksCount,
    filter: {},
    searchKeyword: '',
    orderColumn: {},
    status,
  };
};
const getReceiverTasksFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-receiver-tasks', a));
  return { ...state, status };
};

const proposeNewDeadlineRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-propose-new-deadline-${action.taskId}`);
  return { ...state, status };
};
const proposeNewDeadlineSuccess = (state, action) => {
  const receiverTasks = cloneDeep(state.receiverTasks);
  const idxOfAll = findIndex(receiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    receiverTasks[idxOfAll] = action.response;
  }

  const filteredReceiverTasks = cloneDeep(state.filteredReceiverTasks);
  const idxOfFiltered = findIndex(filteredReceiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredReceiverTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-propose-new-deadline-${action.response.id}`, a));

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks,
    status,
  };
};
const proposeNewDeadlineFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-propose-new-deadline-${action.taskId}`, a));
  return { ...state, status };
};

const cancelNewDeadlineRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-cancel-new-deadline-${action.taskId}`);
  return { ...state, status };
};
const cancelNewDeadlineSuccess = (state, action) => {
  const receiverTasks = cloneDeep(state.receiverTasks);
  const idxOfAll = findIndex(receiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    receiverTasks[idxOfAll] = action.response;
  }

  const filteredReceiverTasks = cloneDeep(state.filteredReceiverTasks);
  const idxOfFiltered = findIndex(filteredReceiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredReceiverTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-cancel-new-deadline-${action.response.id}`, a));

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks,
    status,
  };
};
const cancelNewDeadlineFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-cancel-new-deadline-${action.taskId}`, a));

  return { ...state, status };
};

const markAsCompletedRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-mark-task-ascompleted-${action.taskId}`);

  return { ...state, status };
};
const markAsCompletedSuccess = (state, action) => {
  const receiverTasks = cloneDeep(state.receiverTasks);
  const idxOfAll = findIndex(receiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfAll > -1) {
    receiverTasks[idxOfAll] = action.response;
  }

  const filteredReceiverTasks = cloneDeep(state.filteredReceiverTasks);
  const idxOfFiltered = findIndex(filteredReceiverTasks, (e) => isEqual(e.id, action.response.id));
  if (idxOfFiltered > -1) {
    filteredReceiverTasks[idxOfFiltered] = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-mark-task-ascompleted-${action.response.id}`, a));

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks,
    status,
  };
};
const markAsCompletedFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-mark-task-ascompleted-${action.taskId}`, a));

  return { ...state, status };
};

const removeUncompletedTaskFromQueueRequest = (state, action) => {
  const { category, taskId } = action;

  if (category === 'assigned') {
    const assignerTasks = cloneDeep(state.assignerTasks);
    const idx_all = findIndex(assignerTasks, (e) => isEqual(e.id, taskId));
    if (idx_all > -1) {
      const notCompletedTask = assignerTasks[idx_all];
      notCompletedTask.status = TASK_STATUSES.uncompleted;
      assignerTasks[idx_all] = notCompletedTask;
    }

    const filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
    const idx_filtered = findIndex(filteredAssignerTasks, (e) => isEqual(e.id, taskId));
    if (idx_filtered > -1) {
      const notCompletedTask = filteredAssignerTasks[idx_all];
      notCompletedTask.status = TASK_STATUSES.uncompleted;
      filteredAssignerTasks[idx_filtered] = notCompletedTask;
    }

    return {
      ...state,
      assignerTasks,
      filteredAssignerTasks,
    };
  }
  const receiverTasks = cloneDeep(state.receiverTasks);
  let activeReceivedTasksCount = cloneDeep(state.activeReceivedTasksCount);
  const idx_all = findIndex(receiverTasks, (e) => isEqual(e.id, taskId));
  if (idx_all > -1) {
    const notCompletedTask = receiverTasks[idx_all];
    notCompletedTask.status = TASK_STATUSES.uncompleted;
    receiverTasks[idx_all] = notCompletedTask;
    activeReceivedTasksCount -= 1;
  }

  const filteredReceiverTasks = cloneDeep(state.filteredReceiverTasks);
  const idx_filtered = findIndex(filteredReceiverTasks, (e) => isEqual(e.id, taskId));
  if (idx_filtered > -1) {
    const notCompletedTask = filteredReceiverTasks[idx_filtered];
    notCompletedTask.status = TASK_STATUSES.uncompleted;
    filteredReceiverTasks[idx_filtered] = notCompletedTask;
  }

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks,
    activeReceivedTasksCount,
  };
};

const acknowledgeUncompletedRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-acknowledge-uncompleted-task-${action.taskId}`);
  return { ...state, status };
};
const acknowledgeUncompletedSuccess = (state, action) => {
  const { category, taskId } = action;

  if (category === 'assigned') {
    let assignerTasks = cloneDeep(state.assignerTasks);
    assignerTasks = filter(assignerTasks, (e) => !isEqual(e.id, taskId));

    let filteredAssignerTasks = cloneDeep(state.filteredAssignerTasks);
    filteredAssignerTasks = filter(filteredAssignerTasks, (e) => !isEqual(e.id, taskId));

    return {
      ...state,
      assignerTasks,
      filteredAssignerTasks,
    };
  }
  let receiverTasks = cloneDeep(state.receiverTasks);
  receiverTasks = filter(receiverTasks, (e) => !isEqual(e.id, taskId));

  let filteredReceiverTasks = cloneDeep(state.filteredReceiverTasks);
  filteredReceiverTasks = filter(filteredReceiverTasks, (e) => !isEqual(e.id, taskId));

  return {
    ...state,
    receiverTasks,
    filteredReceiverTasks,
  };
};
const acknowledgeUncompletedFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-acknowledge-uncompleted-task-${action.taskId}`, a));
  return { ...state, status };
};

const getTaskListWithOrderRequest = (state, action) => {
  const { category, column } = action;

  if (category === 'assigned') {
    const { filteredAssignerTasks, orderColumns } = state;
    if (column === '') {
      return { ...state, filteredAssignerTasks, orderColumn: {} };
    }
    const sortedItems = filteredAssignerTasks.sort((a, b) => {
      if (a[column] < b[column]) return -1;
      if (a[column] > b[column]) return 1;

      return 0;
    });

    return {
      ...state,
      filteredAssignerTasks: sortedItems,
      orderColumn: orderColumns.find((x) => x.column === column),
    };
  }
  const { filteredReceiverTasks, orderColumns } = state;
  if (column === '') {
    return { ...state, filteredReceiverTasks, orderColumn: {} };
  }
  const sortedItems = filteredReceiverTasks.sort((a, b) => {
    if (a[column] < b[column]) return -1;
    if (a[column] > b[column]) return 1;

    return 0;
  });

  return {
    ...state,
    filteredReceiverTasks: sortedItems,
    orderColumn: orderColumns.find((x) => x.column === column),
  };
};

const getTaskListSearchRequest = (state, action) => {
  const { category, searchKeyword } = action;

  if (category === 'assigned') {
    const { assignerTasks } = state;
    if (searchKeyword === '') {
      return { ...state, filteredAssignerTasks: assignerTasks };
    }
    const keyword = searchKeyword.toLowerCase();
    const searchItems = assignerTasks.filter(
      (item) =>
        item.name.toLowerCase().indexOf(keyword) > -1 ||
        item.details.toLowerCase().indexOf(keyword) > -1 ||
        item.status.toLowerCase().indexOf(keyword) > -1 ||
        item.urgency.toLowerCase().indexOf(keyword) > -1,
    );

    return {
      ...state,
      filteredAssignerTasks: searchItems,
      searchKeyword,
    };
  }
  const { receiverTasks } = state;
  if (searchKeyword === '') {
    return { ...state, activeReceivedTasksCount: receiverTasks };
  }
  const keyword = searchKeyword.toLowerCase();
  const searchItems = receiverTasks.filter(
    (item) =>
      item.name.toLowerCase().indexOf(keyword) > -1 ||
      item.details.toLowerCase().indexOf(keyword) > -1 ||
      item.status.toLowerCase().indexOf(keyword) > -1 ||
      item.urgency.toLowerCase().indexOf(keyword) > -1,
  );

  return {
    ...state,
    activeReceivedTasksCount: searchItems,
    searchKeyword,
  };
};

const getTaskListWithFilterRequest = (state, action) => {
  const { category, column, value } = action;
  if (category === 'assigned') {
    const { assignerTasks } = state;
    if (column === '' || value === '') {
      return {
        ...state,
        filteredAssignerTasks: assignerTasks,
        filter: {},
      };
    }
    const filteredItems = assignerTasks.filter((item) => item[column] === value);

    return {
      ...state,
      filteredAssignerTasks: filteredItems,
      filter: {
        column,
        value,
      },
    };
  }
  const { receiverTasks } = state;
  if (column === '' || value === '') {
    return {
      ...state,
      filteredReceiverTasks: receiverTasks,
      filter: {},
    };
  }
  const filteredItems = receiverTasks.filter((item) => item[column] === value);

  return {
    ...state,
    filteredReceiverTasks: filteredItems,
    filter: {
      column,
      value,
    },
  };
};

const clearTasksRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [TaskManagementTypes.GET_ASSIGNER_TASKS_REQUEST]: getAssignerTasksRequest,
  [TaskManagementTypes.GET_ASSIGNER_TASKS_SUCCESS]: getAssignerTasksSuccess,
  [TaskManagementTypes.GET_ASSIGNER_TASKS_FAILURE]: getAssignerTasksFailure,

  [TaskManagementTypes.CREATE_NEW_TASK_REQUEST]: createNewTaskRequest,
  [TaskManagementTypes.CREATE_NEW_TASK_SUCCESS]: createNewTaskSuccess,
  [TaskManagementTypes.CREATE_NEW_TASK_FAILURE]: createNewTaskFailure,

  [TaskManagementTypes.CLOSE_TASK_REQUEST]: closeTaskRequest,
  [TaskManagementTypes.CLOSE_TASK_SUCCESS]: closeTaskSuccess,
  [TaskManagementTypes.CLOSE_TASK_FAILURE]: closeTaskFailure,

  [TaskManagementTypes.READ_TASK_REQUEST]: readTaskRequest,
  [TaskManagementTypes.READ_TASK_SUCCESS]: readTaskSuccess,

  [TaskManagementTypes.APPROVE_COMPLETED_REQUEST]: approveCompletedRequest,
  [TaskManagementTypes.APPROVE_COMPLETED_SUCCESS]: approveCompletedSuccess,
  [TaskManagementTypes.APPROVE_COMPLETED_FAILURE]: approveCompletedFailure,

  [TaskManagementTypes.REJECT_COMPLETED_REQUEST]: rejectCompletedRequest,
  [TaskManagementTypes.REJECT_COMPLETED_SUCCESS]: rejectCompletedSuccess,
  [TaskManagementTypes.REJECT_COMPLETED_FAILURE]: rejectCompletedFailure,

  [TaskManagementTypes.APPROVE_NEW_DEADLINE_REQUEST]: approveNewDeadlineRequest,
  [TaskManagementTypes.APPROVE_NEW_DEADLINE_SUCCESS]: approveNewDeadlineSuccess,
  [TaskManagementTypes.APPROVE_NEW_DEADLINE_FAILURE]: approveNewDeadlineFailure,

  [TaskManagementTypes.DECLINE_NEW_DEADLINE_REQUEST]: declineNewDeadlineRequest,
  [TaskManagementTypes.DECLINE_NEW_DEADLINE_SUCCESS]: declineNewDeadlineSuccess,
  [TaskManagementTypes.DECLINE_NEW_DEADLINE_FAILURE]: declineNewDeadlineFailure,

  [TaskManagementTypes.GET_RECEIVER_TASKS_REQUEST]: getReceiverTasksRequest,
  [TaskManagementTypes.GET_RECEIVER_TASKS_SUCCESS]: getReceiverTasksSuccess,
  [TaskManagementTypes.GET_RECEIVER_TASKS_FAILURE]: getReceiverTasksFailure,

  [TaskManagementTypes.PROPOSE_NEW_DEADLINE_REQUEST]: proposeNewDeadlineRequest,
  [TaskManagementTypes.PROPOSE_NEW_DEADLINE_SUCCESS]: proposeNewDeadlineSuccess,
  [TaskManagementTypes.PROPOSE_NEW_DEADLINE_FAILURE]: proposeNewDeadlineFailure,

  [TaskManagementTypes.CANCEL_NEW_DEADLINE_REQUEST]: cancelNewDeadlineRequest,
  [TaskManagementTypes.CANCEL_NEW_DEADLINE_SUCCESS]: cancelNewDeadlineSuccess,
  [TaskManagementTypes.CANCEL_NEW_DEADLINE_FAILURE]: cancelNewDeadlineFailure,

  [TaskManagementTypes.MARK_AS_COMPLETED_REQUEST]: markAsCompletedRequest,
  [TaskManagementTypes.MARK_AS_COMPLETED_SUCCESS]: markAsCompletedSuccess,
  [TaskManagementTypes.MARK_AS_COMPLETED_FAILURE]: markAsCompletedFailure,

  [TaskManagementTypes.REMOVE_UNCOMPLETED_TASK_FROM_QUEUE_REQUEST]: removeUncompletedTaskFromQueueRequest,

  [TaskManagementTypes.ACKNOWLEDGE_UNCOMPLETED_REQUEST]: acknowledgeUncompletedRequest,
  [TaskManagementTypes.ACKNOWLEDGE_UNCOMPLETED_SUCCESS]: acknowledgeUncompletedSuccess,
  [TaskManagementTypes.ACKNOWLEDGE_UNCOMPLETED_FAILURE]: acknowledgeUncompletedFailure,

  [TaskManagementTypes.GET_TASK_LIST_WITH_ORDER_REQUEST]: getTaskListWithOrderRequest,

  [TaskManagementTypes.GET_TASK_LIST_SEARCH_REQUEST]: getTaskListSearchRequest,

  [TaskManagementTypes.GET_TASK_LIST_WITH_FILTER_REQUEST]: getTaskListWithFilterRequest,

  [TaskManagementTypes.CLEAR_TASKS_REQUEST]: clearTasksRequest,
});
